import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class FAQService {
  getFaqList() {
    return axios.get(API_URL + '/faq/published')
  }
  getFilteredFaqList (publishStatus, categoryId, searchText ) {
    searchText = searchText === '' ? 'null' : searchText
    categoryId = categoryId === '' ? 0 : categoryId
    publishStatus = publishStatus === '' ? 'All' : publishStatus
    return axios.get(API_URL + '/faq?publishStatus=' + publishStatus + '&' + 'categoryId=' + categoryId + '&searchText=' + searchText)
  }
  getFaqById (faqId) {
    return axios.get(API_URL + '/faq/' + faqId)
  }
}

export default new FAQService()
